module.exports = __webpack_public_path__ + "img/building.0f45cf7f.jpg";